/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, AfterViewInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { opencanDeactivateDialog } from '../../../../app/shared/functions';
import { ConfirmDialogService } from '@epg/ng-components';

@Component({
  selector: 'app-workflow-designer-placeholder',
  template: '<ng-container #dynamicContent></ng-container>',
  standalone: false
})
export class WorkflowDesignerPlaceholderComponent implements AfterViewInit {
  @ViewChild('dynamicContent', { read: ViewContainerRef }) dynamicContent!: ViewContainerRef;
  componentRef: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private readonly dialogService: ConfirmDialogService
  ) {}

  ngAfterViewInit() {
    import('@epg/workflow-designer-lib').then((m) => {
      this.componentRef = this.dynamicContent.createComponent(m.DesignerComponent);
      const combinedId = this.route.snapshot.paramMap.get('id');
      if (combinedId) {
        const parts = combinedId.split('_');
        const designerId = parts[1] || '';
        this.componentRef.instance.workflowID = designerId;
        this.componentRef.instance.navigateToWorkflowDetail = () => {
          this.router.navigate([`home/workflow`, combinedId]);
        };
      }
    });
  }

  async canDeactivate(): Promise<boolean> {
    // Checks if the user did some changes in the forms.
    if (this.componentRef && this.componentRef.instance.isDirty) {
      return await opencanDeactivateDialog(this.dialogService);
    } else {
      return true;
    }
  }
}
